import React, { useEffect, useState } from 'react';
import { Image, ScrollView, View } from 'react-native';
import { styles } from './ImagesPresentationViewStyle';
import { useWindowSizeContext } from '../../../../../Common/contexts/WindowSizeContext';
import { getImageAspectRatio } from '../../../../../Common/Utils/image.utils';

interface ImagesPresentationViewProps {
    images: any[];
}

interface ImageSize {
    width: number;
    height: number;
}

export const ImagesPresentationView = ({ images }: ImagesPresentationViewProps) => {
    const { width: screenWidth, isMobile } = useWindowSizeContext();
    const maxWidthPicture = isMobile ? screenWidth * 0.75 : screenWidth * 0.25;

    const [imageSizes, setImageSizes] = useState<ImageSize[]>([]);

    function getImageDimensions(url: string): Promise<{ width: number; height: number }> {
        return new Promise((resolve, reject) => {
            Image.getSize(
                url,
                (width, height) => resolve({ width, height }),
                (error) => reject(error)
            );
        });
    }

    useEffect(() => {
        if (images.length === 0) return;

        (async () => {
            try {
                const sizes: ImageSize[] = [];

                for (const image of images) {
                    const dimensions = await getImageDimensions(image.url);
                    const ratio = await getImageAspectRatio(image.url);
                    const scaledHeight = maxWidthPicture / ratio;

                    if (dimensions.width < maxWidthPicture || dimensions.height < scaledHeight) {
                        sizes.push({ width: dimensions.width, height: dimensions.height });
                    } else {
                        sizes.push({ width: maxWidthPicture, height: scaledHeight });
                    }
                }

                setImageSizes(sizes);
            } catch (error) {
                console.error('Error fetching image dimensions:', error);
            }
        })();
    }, [screenWidth, maxWidthPicture, images]);

    if (images.length === 0) return null;

    return (
        <View style={styles.page}>
            <ScrollView horizontal={true} style={styles.scrollView}>
                <View style={styles.line}>
                    {images.map((image: any, index: number) => (
                        <Image
                            key={index}
                            style={[
                                styles.image,
                                index === 0 && { marginLeft: 0 },
                                imageSizes[index] && { width: imageSizes[index].width, height: imageSizes[index].height },
                            ]}
                            source={{ uri: image.url }}
                        />
                    ))}
                </View>
            </ScrollView>
        </View>
    );
};

export default ImagesPresentationView;